module.exports = __webpack_public_path__ + "img/onedrive.0e145741.png";